<template>
  <bar-chart :chartdata="chartdata" :options="customOptions" />
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'CostsAccountGraph',
  components: { BarChart },
  props: {
    costs: {
      type: Object,
      required: true
    },
    activeAccount: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartdata: null,
      selectedDate: null,
      customOptions: this.getChartOptions(),
      colorPalette: [
        '#4caf50', '#2196f3', '#ff9800', '#e91e63', '#9c27b0',
        '#3f51b5', '#00bcd4', '#ffc107', '#8bc34a', '#f44336'
      ]
    }
  },
  watch: {
    costs: {
      deep: true,
      handler: 'fillChartData'
    },
    activeAccount: 'fillChartData'
  },
  methods: {
    getChartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true, ticks: { stepSize: 10 } }]
        },
        legend: { display: false },
        onClick: (event, chartElements) => this.handleChartClick(chartElements)
      }
    },
    handleChartClick (chartElements) {
      if (chartElements.length > 0) {
        const clickedIndex = chartElements[0]._index
        const clickedDate = this.chartdata.labels[clickedIndex]
        this.selectedDate = clickedDate
        this.$emit('update-date', clickedDate)
      }
    },
    generateLabels () {
      const labels = []
      const currentMonth = new Date()
      for (let i = 11; i >= 0; i--) {
        const month = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - i, 1)
        labels.push(month.toLocaleString('default', { month: 'short' }).slice(0, 3))
      }
      return labels
    },
    fillChartData () {
      if (!this.costs[this.activeAccount]) return
      const labels = this.generateLabels()
      const servicesData = this.initializeServiceData(labels)
      const servicesSet = new Set()
      Object.entries(this.costs[this.activeAccount]).forEach(([month, costList]) => {
        if (labels.includes(month)) {
          costList.forEach(({ AccountName, service, amount }) => {
            if (AccountName === this.activeAccount) {
              servicesData[month][service] = (servicesData[month][service] || 0) + amount
              servicesSet.add(service)
            }
          })
        }
      })
      this.chartdata = this.constructChartData(labels, servicesData, servicesSet)
    },
    initializeServiceData (labels) {
      return labels.reduce((acc, label) => ({ ...acc, [label]: {} }), {})
    },
    constructChartData (labels, servicesData, servicesSet) {
      let colorIndex = 0
      const datasets = Array.from(servicesSet).map(service => {
        const data = labels.map(month => servicesData[month][service] || 0)
        return {
          label: service,
          data,
          backgroundColor: this.colorPalette[colorIndex++ % this.colorPalette.length],
          borderColor: 'rgba(0, 0, 0, 0)',
          borderWidth: 1
        }
      })
      return { labels, datasets, chartType: 'bar' }
    }
  },
  created () {
    this.fillChartData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CostsAccountGraph.vue